import React, { useContext } from 'react';
import {
  OutlinedButton,
  ButtonText,
  ButtonIcon,
} from '@prisjakt/ui/button/variants';
import { IconFilter } from '@prisjakt/ui/icon';
import { AppContext } from 'src/components/app-context';
import { ButtonBadge } from '../styles';

interface IFilterToggleButton {
  toggleHandler: () => void;
  activeFilters?: number;
}

const FilterToggleButton = (props: IFilterToggleButton) => {
  const { toggleHandler, activeFilters = [] } = props;
  const { t } = useContext(AppContext);

  return (
    <OutlinedButton
      onClick={toggleHandler}
      selectable
      selected={!!activeFilters}
    >
      <ButtonBadge circular text={activeFilters} />
      <ButtonIcon>
        <IconFilter />
      </ButtonIcon>
      <ButtonText>{t('filter', 'filter.title')}</ButtonText>
    </OutlinedButton>
  );
};

export default FilterToggleButton;
